import { createSelector } from 'reselect';
import { clipSuggestionsCreationProgressSelector } from 'redux/modules/entities';
import {
  isVideoUploadingSelector,
  videoUploadProgressSelector,
} from 'redux/modules/video-upload';
import { State } from 'redux/types';
import { lerp } from 'utils/numbers';
import { calculateUploadProgressPortion } from './utils';

export const creationSuggestionsStatusSelector = createSelector(
  clipSuggestionsCreationProgressSelector,
  creationSuggestionsProgress => creationSuggestionsProgress?.get('status'),
);

export const creationSuggestionsProgressSelector = createSelector(
  clipSuggestionsCreationProgressSelector,
  creationSuggestionsProgress => {
    const progress = creationSuggestionsProgress?.get('progress');

    return Math.round((progress ?? 0) * 100);
  },
);

export const creationSuggestionsEstimatedCompletedAtSelector = createSelector(
  clipSuggestionsCreationProgressSelector,
  creationSuggestionsProgress =>
    creationSuggestionsProgress?.get('estimatedCompletedAt'),
);

export const videoWizardCreationProgressSelector = createSelector(
  [
    creationSuggestionsProgressSelector,
    videoUploadProgressSelector,
    isVideoUploadingSelector,
    (_: State, videoFileSize: number) =>
      videoFileSize ? calculateUploadProgressPortion(videoFileSize) : 20,
  ],
  (apiProgress, uploadProgress, isUploading, uploadPortion) => {
    if (isUploading && uploadProgress !== undefined) {
      return lerp(0, uploadPortion, uploadProgress / 100);
    }

    // if isUploading is false (fallthrough from above) and apiProgress is defined,
    // that means we're past the upload phase of creation and are now onto the
    // API "creation" phase

    if (apiProgress !== undefined && apiProgress > 0) {
      return lerp(uploadPortion, 100, apiProgress / 100);
    }

    // upload completd but API hasn't started yet - show uploadPortion
    // this prevents the jump from uploadPortion --> undefined --> uploadPortion +
    // small API progress
    if (!isUploading && uploadProgress !== undefined && uploadProgress >= 100) {
      return uploadPortion;
    }

    return undefined;
  },
);
